<template>
  <v-tooltip top max-width="250">
    <template v-slot:activator="{ on }">
      <v-card
        outlined
        data-testid="summary-card"
        class="rounded text-center d-flex flex-column align-center align-content-center"
      >
        <div class="py-6 px-3 gray--text text--darken-4">
          <p
            v-if="sanitizedTitle.length"
            class="h4 mt-0 mb-2 font-weight-bold"
            data-testid="summary-card-title"
            v-html="sanitizedTitle"
          ></p>
          <span
            v-if="sanitizedContent.length"
            data-private
            class="body2 mt-2"
            data-testid="summary-card-content"
            v-html="sanitizedContent"
          ></span>
        </div>
        <v-icon
          v-if="sanitizedTooltip.length"
          v-on="on"
          class="tooltip-icon mr-2 mt-2"
          size="20px"
        >
          mdi-help-circle-outline
        </v-icon>
      </v-card>
    </template>
    <span>{{ sanitizedTooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'SummaryCard',

  props: {
    data: {
      type: Object,
      required: true,
    },
  },

  computed: {
    sanitizedTitle() {
      const title = this.data?.title ?? ''
      return this.$sanitize(title)
    },

    sanitizedContent() {
      const content = this.data?.content ?? ''
      return this.$sanitize(content)
    },

    sanitizedTooltip() {
      return this.$sanitize(this.data?.tooltip) ?? ''
    },

    trend() {
      return this.data?.trend ?? 0
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-icon {
  position: absolute;
  right: 0;
  cursor: pointer;
}
</style>
